module.exports = __webpack_public_path__ + "img/watermelon.be340088.svg";